import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate, useSearchParams } from 'react-router'

import { SetPasswordForm } from '@/forms/SetPasswordForm'
import { AuthCard, AuthLayout } from '@/layouts/AuthLayout'

export default function SetPasswordPage() {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const email = searchParams.get('email')
  const token = searchParams.get('token')

  useEffect(() => {
    if (!email || !token) navigate('/auth/login')
  }, [email, token, navigate])

  const { t } = useTranslation(undefined, {
    keyPrefix: 'acceptInvite',
  })

  return (
    <AuthLayout>
      <title>{t('title')}</title>

      <AuthCard title={t('title')} description="Nastavte si heslo, kterým se budete přihlašovat.">
          <SetPasswordForm
            simple
            action={`/api/v2/password-resets/${token}`}
            code={token}
            email={email}
            onSuccess={async () => {
              navigate('/')
            }}
          />
      </AuthCard>
    </AuthLayout>
  )
}
